function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useObservableEagerState } from 'observable-hooks';
import { Alert, useTheme } from '@mui/material';
import { PaletteModeCode, useThemeService } from '@procom-labs/common';
import { WithGorillaInnerTheme } from './with-inner-theme';
var WithGorillaAlert = WithGorillaInnerTheme(Alert);
export var GorillaAlert = function(props) {
    var theme = useTheme();
    var themeService = useThemeService();
    var currentTheme = useObservableEagerState(themeService.baseThemeMode$);
    var themeMode = useMemo(function() {
        return currentTheme === PaletteModeCode.light ? currentTheme : theme.palette.mode;
    }, [
        currentTheme,
        theme.palette.mode
    ]);
    return /*#__PURE__*/ _jsx(WithGorillaAlert, _object_spread_props(_object_spread({
        themeMode: themeMode,
        tabIndex: 0
    }, props), {
        sx: _object_spread_props(_object_spread({}, props === null || props === void 0 ? void 0 : props.sx), {
            border: currentTheme === PaletteModeCode.light ? '1px solid' : undefined
        })
    }));
};
